// Public surface of the connection-health module (BL-1090).
//
// Reached via the `@auctogon/core/connection-health` subpath — deliberately NOT
// re-exported from the package root, per sharing.md § 3 root-barrel hygiene.

export {
    ConnectionHealthProvider,
    useConnectionHealth,
    useRecheckConnection,
    DEFAULT_PROBE_URL,
    type ConnectionHealthProviderProps,
} from './ConnectionHealthProvider';
export {
    createConnectionHealthMonitor,
    type ConnectionEnvironment,
    type ConnectionHealthMonitor,
    type ConnectionHealthMonitorOptions,
    type ConnectionHealthState,
    type MonitorTimers,
} from '../../isomorphic/connection-health/connection-health-monitor';
export {
    createOfflineDetector,
    DEFAULT_BACKOFF_SCHEDULE_MS,
    DEFAULT_FAILURES_TO_ASSERT_OFFLINE,
    type OfflineDetector,
    type OfflineDetectorOptions,
} from '../../isomorphic/connection-health/offline-detector';
export {
    runReachabilityProbe,
    DEFAULT_PROBE_TIMEOUT_MS,
    REACHABILITY_PROBE_PATH,
    type ProbeOutcome,
    type RunReachabilityProbeOptions,
} from '../../isomorphic/connection-health/reachability-probe';
